// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3x8O6","notes":"Notes_notes__Tymse","note":"Notes_note__2IqKc","markdown":"Notes_markdown__3pOI3"};